import { Box, Typography, CircularProgress } from "@mui/material";
import CustomCircularProgress from "../../../components/CustomCircularProgress";

function CircularProgressBar() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "end",
        gap: "1em",
        whiteSpace: "nowrap",
      }}
    >
      <CustomCircularProgress value={86} color="#ea5069" label="345 Leads" />
      <CustomCircularProgress
        value={86}
        color="#22d564"
        label="3500 Engagment"
      />
      <CustomCircularProgress value={52} color="#25aae1" label="Reacts" />
    </Box>
  );
}

export default CircularProgressBar;
